import { createModule } from "saga-slice";
import { call, put } from "redux-saga/effects";
import { createVvinale, findVvinale, listVvinale, updateVvinale } from "./parametrageService";

const parametrageSlice = createModule({
    name: "parametrage",
    initialState: {
        vvinales: [],
        isFetching: false,
        error: null
    },
    reducers: {
        listVvinale: (state) => {
            state.isFetching = true;
        },
        findVvinale: (state) => {
            state.isFetching = true;
        },
        createVvinale: (state) => {
            state.isFetching = true;
        },
        updateVvinale: (state) => {
            state.isFetching = true;
        },
       
        fetchedData: (state, payload) => {
            state.vvinales = payload.body;
        },
        finishFetching: (state) => {
            state.isFetching = false;
        },
        fetchError: (state) => {
            state.isFetching = false;
            state.error = "An error occurred";
        },
    },
    sagas: (A) => ({
        
        *[A.findVvinale]({payload}) {
            try {
                const {data} = yield findVvinale(payload.id);
                yield put(A.finishFetching());
                yield call(payload.onSuccess, data.body);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.createVvinale]({payload}) {
            try {
                console.log(payload.data);
                yield createVvinale(payload.data);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.listVvinale]() {
            try {
                const { data } = yield listVvinale();
                yield put(A.finishFetching());
                yield put(A.fetchedData(data));
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.updateVvinale]({payload}) {
            try {
                yield updateVvinale(payload.data);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        }

    })
})

export default parametrageSlice;
export const parametrageActions = parametrageSlice.actions;
